import { getToken } from "auth/helpers/authApi";
import { apiClient } from "utils/apiClient";

export async function fetchUserFunnel() {
	const organizationResponse = await apiClient("organizations/by-user", { token: getToken() });

	const headerDataObj = {
		companyLogo: organizationResponse.data.logoURI,
		theme: organizationResponse.data.theme.color,
		organizationName: organizationResponse.data.name,
	};

	return { headerDataObj, organizationResponse };
}
